export default "__VITE_ASSET__GLHyP780__"